
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  Eine Ende Februar im chinesischen Fachblatt Chinese Journal of Epidemiology publizierte <Link href='http://weekly.chinacdc.cn/en/article/id/e53946e2-c6c4-41e9-9a9b-fea8db1a8f51' allowWordWrap mdxType="Link">Studie</Link> analysierte 44’672 bestätigte Covid-19-Fälle in Festlandchina bis zum
  11. Februar 2020. Die sehr grosse Anzahl der Fälle machte diese Untersuchung sehr interessant, sie
  wird bis heute herangezogen, um die Sterblichkeit und Gefährlichkeit von Covid-19 abschätzen zu können. Nun haben wir mit Südkorea
  und Italien weitere Länder mit vielen Fällen und offiziellen <Link href='https://www.cdc.go.kr/board/board.es?mid=a30402000000&bid=0030&tag=&act=view&list_no=366523' allowWordWrap mdxType="Link">Daten</Link> der
  Gesundheitsbehörden zu Sterblichkeitsraten in den verschiedenen Bevölkerungsgruppen.
  Das Istituto Superiore di Sanità, Italiens oberstes Gesundheitsinstitut, <Link href='https://www.epicentro.iss.it/coronavirus/bollettino/Bollettino%20sorveglianza%20integrata%20COVID-19_19-marzo%202020.pdf' allowWordWrap mdxType="Link">legte am 19. März eine Studie vor</Link>, in der es alle klinischen Daten der 3047 Toten bis
  zum 19. März analysierte.
    </p>
    <p>
  Das grosse Bild bleibt gleich: Covd-19 ist vor allem für älter Personen und solche
  mit Vorerkrankunge gefährlich. Die einzelnen Sterberaten für die jeweiligen
  Altersgruppen sind aber in Südkorea deutlich tiefer als in China und Italien.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;